import api from './api';

const expensesDashboardService = {
  // Get expenses dashboard statistics
  getDashboardStats: async () => {
    try {
      const response = await api.get('/expenses-dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching expenses dashboard stats:', error);
      throw error;
    }
  }
};

export default expensesDashboardService;

